
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referidos",
      function () {
        return require("private-next-pages/referidos/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referidos"])
      });
    }
  